export enum SkyDropdownMessageType {
  Open = 0,
  Close = 1,
  FocusTriggerButton = 2,
  FocusNextItem = 3,
  FocusPreviousItem = 4,
  Reposition = 5,
  FocusFirstItem = 6
}
